<template>
  <div>
    <!-- Logo Upload Modal -->
    <a-modal v-model="visibleModal" @cancel="closeModal" :footer="false">
      <a-form :form="form" @submit="updateBuildingLogo">
        <a-form-item>
          <a-upload-dragger
            class="row"
            v-decorator="[
              'photo',
              {
                rules: [
                  {
                    required: true,
                    message: 'Ajouter le neauvau logo!',
                  },
                ],
              },
            ]"
            v-if="visibleModal"
            :multiple="false"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :customRequest="addTofileList"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="file-image" />
            </p>
            <p class="ant-upload-text">
              {{ $t("etablissement.clickOrDragToUpload") }}
            </p>
          </a-upload-dragger>
          <div v-if="progress.value > 0" class="row">
            <a-progress :percent="progress.value" />
          </div>
        </a-form-item>
        <div class="form-actions mt-0 row">
          <a-button @click="closeModal" class="col-md-3 offset-md-2 mx-3">
            {{ $t("all.cancel") }}
          </a-button>
          <a-button
            class="col-md-4 offset-md-1 mr-3"
            type="primary"
            htmlType="submit"
            >{{ $t("all.save") }}</a-button
          >
        </div>
      </a-form>
    </a-modal>

    <!-- Building Edit Modal -->
    <a-modal
      v-model="visibleEditModal"
      @cancel="closeEditModal"
      :footer="false"
      :title="$t('etablissement.editBuilding')"
      :width="800"
    >
      <a-form
        :form="editForm"
        @submit="saveBuildingEdit"
        :key="editingBuilding._id"
        v-if="editingBuilding"
      >
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.nom')" required>
              <a-input
                v-decorator="[
                  'name',
                  {
                    initialValue: editingBuilding.name,
                    rules: [
                      {
                        required: true,
                        message: $t('etablissement.nameRequired'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.ArabicName')" required>
              <a-input
                v-decorator="[
                  'ArabicName',
                  {
                    initialValue: editingBuilding.ArabicName,
                    rules: [
                      {
                        required: true,
                        message: $t('etablissement.arabicNameRequired'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.legalName')" required>
              <a-input
                v-decorator="[
                  'legalName',
                  {
                    initialValue: editingBuilding.legalName,
                    rules: [
                      {
                        required: true,
                        message: $t('etablissement.legalNameRequired'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item
              :label="
                editingBuilding && editingBuilding.countryCode === 'KE'
                  ? $t('etablissement.countyLocation')
                  : $t('etablissement.delegeRegional')
              "
              required
            >
              <a-input
                v-decorator="[
                  'delegeRegional',
                  {
                    initialValue: editingBuilding.delegeRegional,
                    rules: [
                      {
                        required: true,
                        message:
                          countryCode === 'KE'
                            ? $t('etablissement.countyLocationRequired')
                            : $t('etablissement.delegeRegionalRequired'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.slogan')">
              <a-input
                v-decorator="[
                  'slogan',
                  {
                    initialValue: editingBuilding.slogan,
                  },
                ]"
                :placeholder="$t('etablissement.slogan')"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.establishmentCode')">
              <a-input
                v-decorator="[
                  'establishmentCode',
                  {
                    initialValue: editingBuilding.establishmentCode,
                  },
                ]"
                :placeholder="$t('etablissement.establishmentCode')"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.postalAddress')">
              <a-input
                v-decorator="[
                  'postalAddress',
                  {
                    initialValue: editingBuilding.postalAddress,
                  },
                ]"
                :placeholder="$t('etablissement.postalAddress')"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.headMaster')" required>
              <a-input
                v-decorator="[
                  'headMaster',
                  {
                    initialValue: editingBuilding.headMaster,
                    rules: [
                      {
                        required: true,
                        message: $t('etablissement.headMasterRequired'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.headMasterFrench')">
              <a-input
                :placeholder="$t('etablissement.headMasterFrench')"
                v-decorator="[
                  'headMasterFrench',
                  {
                    initialValue: editingBuilding.headMasterFrench,
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.headMasterGender')">
              <a-radio-group
                v-decorator="[
                  'headMasterGender',
                  {
                    initialValue: editingBuilding.headMasterGender || 'male',
                  },
                ]"
              >
                <a-radio value="male">{{ $t("etablissement.male") }}</a-radio>
                <a-radio value="female">{{
                  $t("etablissement.female")
                }}</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.RIB')">
              <a-input
                v-decorator="[
                  'RIB',
                  {
                    initialValue: editingBuilding.RIB,
                    rules: [
                      {
                        pattern: /^\d{20}$/,
                        message: this.$t('etablissement.rib20Digits'),
                      },
                    ],
                  },
                ]"
                :placeholder="$t('etablissement.RIB')"
                maxlength="20"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <a-form-item :label="$t('etablissement.additionalDirectors')">
              <div
                v-for="(director, index) in additionalDirectorsList"
                :key="index"
                class="director-item"
              >
                <a-input
                  v-model="director.name"
                  type="text"
                  :placeholder="$t('etablissement.directorName')"
                  class="director-input"
                />
                <a-button
                  type="danger"
                  icon="delete"
                  @click="removeAdditionalDirector(index)"
                />
              </div>
              <a-button
                type="dashed"
                icon="plus"
                @click="addAdditionalDirector"
                class="add-director-btn"
              >
                {{ $t("etablissement.addDirector") }}
              </a-button>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <a-form-item
              :label="
                editingBuilding && editingBuilding.countryCode === 'KE'
                  ? $t('etablissement.schoolNEMISNumber')
                  : $t('etablissement.MF')
              "
            >
              <a-input
                v-decorator="[
                  'MF',
                  {
                    initialValue: editingBuilding.MF,
                  },
                ]"
                placeholder="12345678"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.adress')" required>
              <a-input
                v-decorator="[
                  'adress',
                  {
                    initialValue: editingBuilding.adress,
                    rules: [
                      {
                        required: true,
                        message: $t('requis.adresse'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <a-form-item :label="$t('etablissement.geoLat')">
              <a-input-number
                style="width: 100%"
                :min="-90"
                :max="90"
                :step="0.000001"
                v-decorator="[
                  'geoLat',
                  {
                    initialValue:
                      editingBuilding.geo && editingBuilding.geo.lat != null
                        ? editingBuilding.geo.lat
                        : undefined,
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item :label="$t('etablissement.geoLng')">
              <a-input-number
                style="width: 100%"
                :min="-180"
                :max="180"
                :step="0.000001"
                v-decorator="[
                  'geoLng',
                  {
                    initialValue:
                      editingBuilding.geo && editingBuilding.geo.lng != null
                        ? editingBuilding.geo.lng
                        : undefined,
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item :label="$t('etablissement.geoRadius')">
              <a-input-number
                style="width: 100%"
                :min="50"
                :max="5000"
                :step="10"
                v-decorator="[
                  'geoRadiusMeters',
                  {
                    initialValue:
                      (editingBuilding.geo &&
                        editingBuilding.geo.radiusMeters) ||
                      200,
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-2">
            <a-alert
              :message="$t('etablissement.geoHint')"
              type="info"
              show-icon
              banner
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.mainPhone')" required>
              <phone-number-input
                :default-country-code="countryCode === 'KE' ? 'KE' : 'TN'"
                v-decorator="[
                  'phone',
                  {
                    initialValue: editingBuilding.phone,
                    rules: [
                      {
                        required: true,
                        message: '',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.mainEmail')">
              <a-input
                v-decorator="[
                  'email',
                  {
                    initialValue: editingBuilding.email,
                    rules: [{ type: 'email', message: $t('requis.email') }],
                  },
                ]"
                type="email"
                placeholder="exemple@ecole.com"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <a-form-item
              :label="$t('etablissement.additionalPhones')"
              :required="
                editingBuilding && editingBuilding.countryCode === 'KE'
              "
            >
              <div
                v-if="editingBuilding && editingBuilding.countryCode === 'KE'"
                class="mb-2"
              >
                <a-alert
                  :message="$t('etablissement.kenyaPhoneRequirement')"
                  type="info"
                  banner
                  show-icon
                />
              </div>
              <div
                v-for="(_, index) in additionalPhonesList"
                :key="index"
                class="phone-item"
              >
                <phone-number-input
                  :value="additionalPhonesList[index]"
                  :default-country-code="countryCode === 'KE' ? 'KE' : 'TN'"
                  class="phone-input"
                  @raw-change="(val) => $set(additionalPhonesList, index, val)"
                />
                <a-button
                  type="danger"
                  icon="delete"
                  @click="removeAdditionalPhone(index)"
                  :disabled="
                    editingBuilding &&
                    editingBuilding.countryCode === 'KE' &&
                    additionalPhonesList.length <= 2
                  "
                />
              </div>
              <a-button
                type="dashed"
                icon="plus"
                @click="addAdditionalPhone"
                class="add-phone-btn"
              >
                {{ $t("etablissement.addPhone") }}
              </a-button>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.additionalEmails')">
              <div
                v-for="(_, index) in additionalEmailsList"
                :key="index"
                class="email-item"
              >
                <a-input
                  v-model="additionalEmailsList[index]"
                  type="email"
                  :placeholder="$t('etablissement.email')"
                  class="email-input"
                />
                <a-button
                  type="danger"
                  icon="delete"
                  @click="removeAdditionalEmail(index)"
                  :disabled="additionalEmailsList.length === 0"
                />
              </div>
              <a-button
                type="dashed"
                icon="plus"
                @click="addAdditionalEmail"
                class="add-email-btn"
              >
                {{ $t("etablissement.addEmail") }}
              </a-button>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.type')" required>
              <a-select
                mode="multiple"
                v-decorator="[
                  'type',
                  {
                    initialValue: editingBuilding.type,
                    rules: [
                      {
                        required: true,
                        message: $t('etablissement.typeRequired'),
                      },
                    ],
                  },
                ]"
              >
                <template v-if="editingBuilding.countryCode === 'KE'">
                  <a-select-option value="preSchool">{{
                    $t("etablissement.preSchool")
                  }}</a-select-option>
                  <a-select-option value="prePrimary">{{
                    $t("etablissement.prePrimary")
                  }}</a-select-option>
                  <a-select-option value="middle">{{
                    $t("etablissement.middle")
                  }}</a-select-option>
                  <a-select-option value="junior">{{
                    $t("etablissement.junior")
                  }}</a-select-option>
                  <a-select-option value="senior">{{
                    $t("etablissement.senior")
                  }}</a-select-option>
                </template>
                <template v-else>
                  <a-select-option value="jardinEnfant">{{
                    $t("etablissement.jardinEnfant")
                  }}</a-select-option>
                  <a-select-option value="ecole">{{
                    $t("etablissement.ecole")
                  }}</a-select-option>
                  <a-select-option value="college">{{
                    $t("etablissement.college")
                  }}</a-select-option>
                  <a-select-option value="lycee">{{
                    $t("etablissement.lycee")
                  }}</a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.currency')" required>
              <a-select
                v-decorator="[
                  'currency',
                  {
                    initialValue: editingBuilding.currency || 'TND',
                    rules: [
                      {
                        required: true,
                        message: $t('etablissement.currencyRequired'),
                      },
                    ],
                  },
                ]"
                @change="handleCurrencyChange"
              >
                <a-select-option value="TND">{{
                  $t("etablissement.TND")
                }}</a-select-option>
                <a-select-option value="KES">{{
                  $t("etablissement.KES")
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.reductionType')" required>
              <a-select
                v-decorator="[
                  'reductionType',
                  {
                    initialValue: editingBuilding.reductionType,
                    rules: [
                      {
                        required: true,
                        message: $t('etablissement.reductionTypeRequired'),
                      },
                    ],
                  },
                ]"
                :key="selectedCurrency"
              >
                <a-select-option value="pourcentage">{{
                  $t("etablissement.pourcentage")
                }}</a-select-option>
                <a-select-option
                  v-if="selectedCurrency === 'TND'"
                  value="dinar"
                  >{{ $t("etablissement.dinar") }}</a-select-option
                >
                <a-select-option
                  v-if="selectedCurrency === 'KES'"
                  value="shilling"
                  >{{ $t("etablissement.shilling") }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="form-actions mb-0 row">
          <a-button @click="closeEditModal" class="mx-3" style="float: right">
            {{ $t("all.cancel") }}
          </a-button>
          <a-button
            type="primary"
            class="mr-3"
            style="float: right"
            :loading="loadingEditUpdate"
            :disabled="loadingEditUpdate"
            htmlType="submit"
            >{{ $t("all.save") }}</a-button
          >
        </div>
      </a-form>
    </a-modal>

    <!-- Configuration Modal -->
    <a-modal
      :dialog-style="{ top: '10px' }"
      v-if="selectedBuilding"
      v-model="visibleConfigModal"
      @cancel="closeAccessModal"
      :footer="false"
      :title="$t('etablissement.editConfig')"
      :width="700"
    >
      <a-form
        :form="configForm"
        @submit="updateBuildingConfig"
        :key="selectedBuilding._id"
      >
        <div class="row">
          <div class="col-md-12">
            <a-form-item class="mt-0 mb-0">
              <a-alert
                :message="$t('etablissement.alertShowFeesParentPayment')"
                banner
                type="info"
                show-icon
                closable
              />

              <a-switch
                class="switch"
                v-model="selectedBuilding.config.showFeesParentPayment"
              >
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
              <label style="margin-left: 10px">
                <i class="fa fa-money"></i>
                {{ $t("etablissement.showFeesParentPayment") }}
              </label>
            </a-form-item>

            <!--
            TODO to be added in next release 3.0.1
            <a-form-item class="mt-0 mb-0">
              <a-alert
                :message="$t('etablissement.alertshowInvoicesParentPayment')"
                banner
                type="info"
                show-icon
                closable
              />

              <a-switch
                class="switch"
                v-model="selectedBuilding.config.showInvoicesParentPayment"
              >
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
              <label style="margin-left: 10px">
                <i class="fa fa-weixin"></i>
                {{ $t("etablissement.showInvoicesParentPayment") }}
              </label>
            </a-form-item> -->

            <a-form-item class="mt-0 mb-0">
              <a-alert
                :message="$t('etablissement.alertDisableChat')"
                banner
                type="info"
                show-icon
                closable
              />

              <a-switch
                class="switch"
                v-model="selectedBuilding.config.teacherParentChat"
              >
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
              <label style="margin-left: 10px">
                <i class="fa fa-weixin"></i> {{ $t("menu.ptchat") }}
              </label>
            </a-form-item>

            <a-form-item class="mt-0 mb-0">
              <a-alert
                :message="
                  $t('etablissement.alertDisableTeacherParentGroupChat')
                "
                banner
                type="info"
                show-icon
                closable
              />

              <a-switch
                class="switch"
                v-model="selectedBuilding.config.teacherParentGroupChat"
              >
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
              <label style="margin-left: 10px">
                <i class="fa fa-users"></i>
                {{ $t("etablissement.teacherParentGroupChat") }}
              </label>
            </a-form-item>

            <a-form-item class="mt-0 mb-0">
              <a-alert
                :message="$t('etablissement.alertRequirePunishmentValidation')"
                banner
                type="info"
                show-icon
                closable
              />

              <a-switch
                class="switch"
                v-model="selectedBuilding.config.requirePunishmentValidation"
              >
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
              <label style="margin-left: 10px">
                <i class="fa fa-gavel"></i>
                {{ $t("etablissement.requirePunishmentValidation") }}
              </label>
            </a-form-item>

            <a-form-item class="mt-0 mb-0">
              <a-alert
                :message="$t('etablissement.alertTeacherAttendanceEnabled')"
                banner
                type="info"
                show-icon
                closable
              />

              <a-switch
                class="switch"
                v-model="selectedBuilding.config.teacherAttendanceEnabled"
              >
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
              <label style="margin-left: 10px">
                <i class="fa fa-clock-o"></i>
                {{ $t("etablissement.teacherAttendanceEnabled") }}
              </label>
            </a-form-item>

            <a-form-item class="mt-0 mb-0">
              <a-alert
                :message="
                  $t('etablissement.alertRequireTeacherAttendanceValidation')
                "
                banner
                type="info"
                show-icon
                closable
              />

              <a-switch
                class="switch"
                v-model="
                  selectedBuilding.config.requireTeacherAttendanceValidation
                "
                :disabled="
                  selectedBuilding.config.teacherAttendanceEnabled === false
                "
              >
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
              <label style="margin-left: 10px">
                <i class="fa fa-check-square-o"></i>
                {{ $t("etablissement.requireTeacherAttendanceValidation") }}
              </label>
            </a-form-item>
          </div>
        </div>
        <div class="form-actions mb-0 row">
          <a-button @click="closeAccessModal" class="mx-3" style="float: right">
            {{ $t("all.cancel") }}
          </a-button>
          <a-button
            type="primary"
            class="mr-3"
            style="float: right"
            :loading="loadingACUpdate"
            :disabled="loadingACUpdate"
            htmlType="submit"
            >{{ $t("all.save") }}</a-button
          >
        </div>
      </a-form>
    </a-modal>

    <a-table
      :loading="tableLeading"
      :rowKey="'_id'"
      :columns="columns"
      :data-source="data"
      :pagination="true"
      :scroll="{ x: 'max-content' }"
    >
      <template slot="logoUpload" slot-scope="text, record">
        <a-popover
          :title="$t('etablissement.clickForUploadLogo')"
          trigger="hover"
        >
          <a-avatar
            class="building-logo"
            :src="record.logo"
            :size="64"
            icon="user"
            @click="changeImage(record)"
          />
        </a-popover>
      </template>
      <div
        slot="filterDropdown"
        slot-scope="{
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          column,
        }"
        style="padding: 8px"
      >
        <a-input
          v-ant-ref="(c) => (searchInput = c)"
          :placeholder="
            $t('action.search') + ' ' + $t('etablissement.' + column.dataIndex)
          "
          :value="selectedKeys[0]"
          style="width: 188px; margin-bottom: 8px; display: block"
          @change="
            (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
          "
          @pressEnter="
            () => handleSearch(selectedKeys, confirm, column.dataIndex)
          "
        />
        <a-button
          type="primary"
          icon="search"
          size="small"
          style="width: 90px; margin-right: 8px"
          @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
        >
          {{ $t("action.search") }}
        </a-button>
        <a-button
          size="small"
          style="width: 90px"
          @click="() => handleReset(clearFilters)"
        >
          {{ $t("action.reset") }}
        </a-button>
      </div>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="search"
        :style="{ color: filtered ? '#108ee9' : undefined }"
      />

      <template
        v-for="col in [
          'name',
          'legalName',
          'ArabicName',
          'delegeRegional',
          'headMaster',
          'RIB',
          'MF',
          'createdAt',
          'phone',
          'email',
          'adress',
        ]"
        :slot="col"
        slot-scope="text, record"
      >
        <div v-if="col != 'createdAt'" :key="col + '-value'">
          <template>{{ text }}</template>
        </div>
        <div v-else :key="col + '-createdAt'">
          <template>{{ text }}</template>
        </div>
      </template>
      <template :slot="'reductionType'" slot-scope="text, record">
        <template>{{ $t("etablissement." + text) }}</template>
      </template>
      <template :slot="'type'" slot-scope="text, record">
        <template>
          <a-tag
            v-for="(type, index) in text"
            :key="index"
            style="margin-right: 4px"
          >
            {{ $t("etablissement." + type) }}
          </a-tag>
        </template>
      </template>
      <span slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <a-button type="primary" @click="() => openEditModal(record)">
            <a-icon type="edit" />
            {{ $t("all.edit") }}
          </a-button>
          <a-button
            icon="setting"
            class="ml-2"
            @click="openConfigModal(record)"
          >
            {{ $t("etablissement.config") }}
          </a-button>
        </div>
      </span>
    </a-table>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import moment from "moment";
import { mapState } from "vuex";
import cloneDeep from "lodash/cloneDeep";
var buildingsData = [];
import { uploadFilesToS3 } from "@/services/uploadService";
export default {
  name: "buildings",
  computed: {
    ...mapState(["settings", "user"]),
    activeBuilding() {
      return this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode;
    },
    columns() {
      return [
        {
          title: this.$t("etablissement.logo"),
          dataIndex: "logoUpload",
          key: "logoUpload",
          scopedSlots: { customRender: "logoUpload" },
        },
        {
          title: this.$t("etablissement.name"),
          dataIndex: "name",
          key: "name",
          sorter: (a, b) => a.name.length - b.name.length,
          sortDirections: ["descend", "ascend"],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "name",
          },
          onFilter: (value, record) =>
            String(record.name ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("etablissement.ArabicName"),
          dataIndex: "ArabicName",
          key: "ArabicName",
          sorter: (a, b) => a.ArabicName.length - b.ArabicName.length,
          sortDirections: ["descend", "ascend"],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "ArabicName",
          },
          onFilter: (value, record) =>
            String(record.ArabicName ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("etablissement.legalName"),
          dataIndex: "legalName",
          key: "legalName",
          sorter: (a, b) => a.legalName.length - b.legalName.length,
          sortDirections: ["descend", "ascend"],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "legalName",
          },
          onFilter: (value, record) =>
            String(record.legalName ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },

        {
          title:
            this.countryCode === "KE"
              ? this.$t("etablissement.countyLocation")
              : this.$t("etablissement.delegeRegional"),
          dataIndex: "delegeRegional",
          key: "delegeRegional",
          sorter: (a, b) => a.delegeRegional.length - b.delegeRegional.length,
          sortDirections: ["descend", "ascend"],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "delegeRegional",
          },
          onFilter: (value, record) =>
            String(record.delegeRegional ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },

        {
          title: this.$t("etablissement.headMaster"),
          dataIndex: "headMaster",
          key: "headMaster",
          sorter: (a, b) => a.headMaster.length - b.headMaster.length,
          sortDirections: ["descend", "ascend"],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "headMaster",
          },
          onFilter: (value, record) =>
            String(record.headMaster ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("etablissement.RIB"),
          dataIndex: "RIB",
          key: "RIB",
          sorter: (a, b) => {
            const aRIB = a.RIB || "";
            const bRIB = b.RIB || "";
            return aRIB.length - bRIB.length;
          },
          sortDirections: ["descend", "ascend"],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "RIB",
          },
          onFilter: (value, record) =>
            String(record.RIB ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title:
            (this.editingBuilding?.countryCode || this.countryCode) === "KE"
              ? this.$t("etablissement.schoolNEMISNumber")
              : this.$t("etablissement.MF"),
          dataIndex: "MF",
          key: "MF",
          sorter: (a, b) => (a.MF ? a.MF.length - b.MF.length : 0),
          sortDirections: ["descend", "ascend"],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "MF",
          },
          onFilter: (value, record) =>
            String(record.MF ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("etablissement.dateEnregistrement"),
          dataIndex: "createdAt",
          key: "createdAt",
          editable: false,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "createdAt",
          },
          onFilter: (value, record) =>
            String(record.createdAt ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("etablissement.phone"),
          dataIndex: "phone",
          key: "phone",
          sorter: (a, b) => a.phone - b.phone,
          sortDirections: ["descend", "ascend"],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "phone",
          },
          onFilter: (value, record) =>
            String(record.phone ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("etablissement.email"),
          dataIndex: "email",
          key: "email",
          sorter: (a, b) => (a.email ? a.email.length - b.email.length : 0),
          sortDirections: ["descend", "ascend"],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "email",
          },
          onFilter: (value, record) =>
            String(record.email ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("etablissement.adress"),
          dataIndex: "adress",
          key: "adress",
          sorter: (a, b) => a.adress.length - b.adress.length,
          sortDirections: ["descend", "ascend"],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "adress",
          },
          onFilter: (value, record) =>
            String(record.adress ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("etablissement.type"),
          dataIndex: "type",
          key: "type",
          sortDirections: ["descend", "ascend"],
          width: 200,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "type",
          },
          onFilter: (value, record) => {
            const t = record.type;
            const haystack = Array.isArray(t) ? t.join(" ") : String(t ?? "");
            return haystack.toLowerCase().includes(String(value).toLowerCase());
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("etablissement.reductionType"),
          dataIndex: "reductionType",
          key: "reductionType",
          sortDirections: ["descend", "ascend"],
          width: 200,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "reductionType",
          },
          onFilter: (value, record) =>
            String(record.reductionType ?? "")
              .toLowerCase()
              .includes(String(value).toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("action.actions"),
          dataIndex: "operation",
          fixed: "right",
          scopedSlots: { customRender: "operation" },
        },
      ];
    },
  },

  async created() {
    this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - Etablissements",
    });

    let buildingList = [];
    this.user.building.forEach((currentItem) => {
      buildingList.push(currentItem._id);
    });

    await apiClient
      .post("/buildings/presignedLogos", {
        buildingList: buildingList,
      })
      .then((res) => {
        buildingsData = [...res.data];
        buildingsData = buildingsData.map((elem) => {
          // Transform reductionType from "amount" to "dinar"/"shilling" for display
          const transformedElem = this.transformReductionTypeForDisplay({
            ...elem,
          });
          return {
            ...transformedElem,
            logoUpload: transformedElem._id,
            key: transformedElem._id,
            createdAt: moment(transformedElem.createdAt).format("DD/MM/YYYY"),
          };
        });
        this.data = buildingsData;
        this.tableLeading = false;
      })
      .catch(() => this.$message.error($t("error.aucEtablissement")));
  },
  data() {
    return {
      loadingACUpdate: false,
      selectedBuilding: null,
      visibleConfigModal: false,
      form: this.$form.createForm(this),
      configForm: this.$form.createForm(this),
      tableLeading: true,
      data: null,
      fileList: [],
      visibleModal: false,
      buildingLogo: null,
      buildingInModal: {},
      progress: { value: 0 },
      visibleEditModal: false,
      editingBuilding: null,
      editForm: this.$form.createForm(this),
      loadingEditUpdate: false,
      selectedCurrency: "TND",
      additionalEmailsList: [],
      additionalPhonesList: [],
      additionalDirectorsList: [],
      searchInput: null,
    };
  },
  methods: {
    // Transform reductionType from backend "amount" to frontend "dinar"/"shilling"
    transformReductionTypeForDisplay(building) {
      if (
        building &&
        building.reductionType === "amount" &&
        building.currency
      ) {
        building.reductionType =
          building.currency === "TND" ? "dinar" : "shilling";
      }
      return building;
    },
    // Transform reductionType from frontend "dinar"/"shilling" to backend "amount"
    transformReductionTypeForBackend(reductionType) {
      if (reductionType === "dinar" || reductionType === "shilling") {
        return "amount";
      }
      return reductionType;
    },
    closeModal() {
      this.visibleModal = false;
      this.fileList = [];
      this.buildingLogo = null;
    },
    updateBuildingLogo(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (err) return;
        try {
          const uploadedKeys = await uploadFilesToS3(
            [this.buildingLogo],
            "logo",
            this.progress,
            this.buildingInModal.dbName
          );
          // Step 3: Update Building Info
          const response = await apiClient.patch(
            `/buildings/${this.buildingInModal._id}/logo`,
            {
              logo: uploadedKeys[0],
            }
          );
          const { imageURL } = response.data;
          // Update UI
          this.data = this.data.map((b) =>
            b._id === this.buildingInModal._id ? { ...b, logo: imageURL } : b
          );

          this.closeModal();
          this.updateBuildingList(this.buildingInModal._id, {
            logo: imageURL,
          });
          this.$message.success(this.$t("success.logoMSA"));
        } catch (error) {
          console.error("Upload Error:", error);
          this.$message.error(this.$t("error.impoTelecharger"));
        }
      });
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error(this.$t("error.fichiers"));
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error(this.$t("error.image"));
      }
      if (isJpgOrPng && isLt2M) {
        this.$message.success(
          this.$t("success.fileUploadedPleaseSave", { name: file.name })
        );
        this.buildingLogo = file;
      }
      return isJpgOrPng && isLt2M;
    },
    addTofileList() {
      this.fileList = [this.buildingLogo];
    },
    changeImage(record) {
      this.progress = { value: 0 };
      this.visibleModal = true;
      this.buildingInModal = record;
    },
    updateBuildingList(key, update) {
      const targetDB = this.data.filter((b) => b._id == key)[0];
      let target = this.settings.image.filter(
        (b) => b.db == targetDB.dbName
      )[0];
      if (update.logo) target.logo = update.logo;
      if (update.name) target.name = update.name;
      const newBuildingsList = this.settings.image.map((b) =>
        b.db == target.db ? target : b
      );
      let UserTarget = this.user.building.filter(
        (b) => b.dbName == targetDB.dbName
      )[0];
      UserTarget.type = update.type;
      UserTarget.reductionType = update.reductionType;

      const newUserBuildingsList = this.user.building.map((b) =>
        b.dbName == UserTarget.dbName ? UserTarget : b
      );
      this.$store.commit("user/SET_STATE", {
        building: newUserBuildingsList,
      });

      this.$store.commit("settings/CHANGE_SETTING", {
        setting: "image",
        value: newBuildingsList,
      });
    },
    // removed function updateBuilding(): unused
    openEditModal(record) {
      // Transform reductionType from "amount" to "dinar"/"shilling" for display
      const transformedRecord = this.transformReductionTypeForDisplay({
        ...record,
      });
      this.editingBuilding = transformedRecord;
      this.selectedCurrency = transformedRecord.currency || "TND";
      // Initialize additional emails list
      this.additionalEmailsList = transformedRecord.additionalEmails
        ? [...transformedRecord.additionalEmails]
        : [];
      // Initialize additional phones list
      this.additionalPhonesList = transformedRecord.additionalPhones
        ? [...transformedRecord.additionalPhones]
        : [];
      // For Kenya, ensure at least 2 additional phone fields are present
      if (
        transformedRecord.countryCode === "KE" &&
        this.additionalPhonesList.length < 2
      ) {
        while (this.additionalPhonesList.length < 2) {
          this.additionalPhonesList.push("");
        }
      }
      // Initialize additional directors list
      this.additionalDirectorsList = transformedRecord.additionalDirectors
        ? transformedRecord.additionalDirectors.map((dir) => ({
            name: dir.name || "",
          }))
        : [];
      this.visibleEditModal = true;
    },
    closeEditModal() {
      this.visibleEditModal = false;
      this.editingBuilding = null;
      this.selectedCurrency = "TND";
      this.additionalEmailsList = [];
      this.additionalPhonesList = [];
      this.additionalDirectorsList = [];
    },
    addAdditionalEmail() {
      this.additionalEmailsList.push("");
    },
    removeAdditionalEmail(index) {
      this.additionalEmailsList.splice(index, 1);
    },
    addAdditionalPhone() {
      this.additionalPhonesList.push("");
    },
    removeAdditionalPhone(index) {
      // For Kenya, prevent removing if it would leave less than 2 phones
      if (
        this.editingBuilding &&
        this.editingBuilding.countryCode === "KE" &&
        this.additionalPhonesList.length <= 2
      ) {
        this.$message.warning(this.$t("etablissement.kenyaPhoneRequirement"));
        return;
      }
      this.additionalPhonesList.splice(index, 1);
    },
    addAdditionalDirector() {
      this.additionalDirectorsList.push({ name: "" });
    },
    removeAdditionalDirector(index) {
      this.additionalDirectorsList.splice(index, 1);
    },
    handleCurrencyChange(value) {
      this.selectedCurrency = value;
      // Auto-update reduction type based on currency
      const currentReductionType = this.editForm.getFieldValue("reductionType");
      if (value === "TND") {
        // If current is shilling, change to dinar
        if (currentReductionType === "shilling") {
          this.editForm.setFieldsValue({ reductionType: "dinar" });
        }
      } else if (value === "KES") {
        // If current is dinar, change to shilling
        if (currentReductionType === "dinar") {
          this.editForm.setFieldsValue({ reductionType: "shilling" });
        }
      }
    },
    saveBuildingEdit(e) {
      e.preventDefault();
      this.editForm.validateFieldsAndScroll((err, values) => {
        if (err) {
          return;
        }

        // --- Phone validation (main phone) ---
        const phoneVal = (values.phone || "").trim();
        if (!phoneVal) {
          this.$message.error(this.$t("phoneInput.required"));
          return;
        }
        if (
          phoneVal.startsWith("+216") &&
          phoneVal.replace(/\D/g, "").length !== 11
        ) {
          this.$message.error(this.$t("requis.telephone"));
          return;
        }
        if (
          phoneVal.startsWith("+254") &&
          phoneVal.replace(/\D/g, "").length !== 13
        ) {
          this.$message.error(this.$t("requis.telephoneKE"));
          return;
        }

        // --- Additional phones validation ---
        const additionalPhones = this.additionalPhonesList.filter(
          (phone) => phone && phone.trim() !== ""
        );

        // Kenya: require at least 2 additional phones
        if (this.editingBuilding && this.editingBuilding.countryCode === "KE") {
          if (additionalPhones.length < 2) {
            this.$message.error(this.$t("etablissement.kenyaPhoneRequirement"));
            return;
          }
        }

        // Validate digit count for each additional phone (TN/KE only)
        let hasInvalidAdditionalPhone = false;
        for (const phone of additionalPhones) {
          const digits = phone.replace(/\D/g, "");
          if (phone.startsWith("+216") && digits.length !== 11) {
            this.$message.error(this.$t("requis.telephone"));
            hasInvalidAdditionalPhone = true;
            break;
          }
          if (phone.startsWith("+254") && digits.length !== 13) {
            this.$message.error(this.$t("requis.telephoneKE"));
            hasInvalidAdditionalPhone = true;
            break;
          }
        }
        if (hasInvalidAdditionalPhone) {
          return;
        }

        this.loadingEditUpdate = true;

        const updates = {
          name: values.name,
          ArabicName: values.ArabicName,
          slogan: values.slogan,
          legalName: values.legalName,
          delegeRegional: values.delegeRegional,
          headMaster: values.headMaster,
          headMasterFrench: values.headMasterFrench,
          headMasterGender: values.headMasterGender,
          additionalDirectors: this.additionalDirectorsList.filter(
            (dir) => dir.name && dir.name.trim() !== ""
          ),
          RIB: values.RIB,
          MF: values.MF,
          phone: values.phone,
          additionalPhones: additionalPhones,
          email: values.email,
          additionalEmails: this.additionalEmailsList.filter(
            (email) => email && email.trim() !== ""
          ),
          adress: values.adress,
          postalAddress: values.postalAddress,
          geo: {
            lat:
              values.geoLat !== undefined && values.geoLat !== null
                ? Number(values.geoLat)
                : null,
            lng:
              values.geoLng !== undefined && values.geoLng !== null
                ? Number(values.geoLng)
                : null,
            radiusMeters:
              values.geoRadiusMeters !== undefined &&
              values.geoRadiusMeters !== null
                ? Number(values.geoRadiusMeters)
                : 200,
          },
          type: values.type,
          reductionType: this.transformReductionTypeForBackend(
            values.reductionType
          ),
          currency: values.currency,
          establishmentCode: values.establishmentCode,
        };

        apiClient
          .patch("/buildings/" + this.editingBuilding._id, { data: updates })
          .then((res) => {
            // Transform reductionType back to "dinar"/"shilling" for display
            const displayUpdates = {
              ...updates,
              reductionType: values.reductionType, // Keep the frontend value for display
            };
            // Update the data array
            this.data = this.data.map((b) =>
              b._id === this.editingBuilding._id
                ? { ...b, ...displayUpdates }
                : b
            );

            // Update building list in store (use display value)
            this.updateBuildingList(this.editingBuilding._id, displayUpdates);

            this.closeEditModal();
            this.$message.success(
              this.$t("success.buildingMSA", {
                name: values.name,
              })
            );
            this.$emit("reload");
          })
          .catch(() =>
            this.$message.error(this.$t("error.changementNonEffectue"))
          )
          .finally(() => (this.loadingEditUpdate = false));
      });
    },
    openConfigModal(record) {
      this.selectedBuilding = cloneDeep(record || {});
      if (!this.selectedBuilding.config) {
        this.$set(this.selectedBuilding, "config", {});
      }

      if (this.selectedBuilding.config.teacherParentChat == null) {
        this.$set(this.selectedBuilding.config, "teacherParentChat", true);
      }
      if (this.selectedBuilding.config.teacherParentGroupChat == null) {
        this.$set(this.selectedBuilding.config, "teacherParentGroupChat", true);
      }
      if (this.selectedBuilding.config.requirePunishmentValidation == null) {
        this.$set(
          this.selectedBuilding.config,
          "requirePunishmentValidation",
          false
        );
      }
      if (this.selectedBuilding.config.teacherAttendanceEnabled == null) {
        this.$set(
          this.selectedBuilding.config,
          "teacherAttendanceEnabled",
          true
        );
      }
      if (
        this.selectedBuilding.config.requireTeacherAttendanceValidation == null
      ) {
        this.$set(
          this.selectedBuilding.config,
          "requireTeacherAttendanceValidation",
          false
        );
      }
      this.visibleConfigModal = true;
    },
    closeAccessModal() {
      this.visibleConfigModal = false;
    },
    updateBuildingConfig(e) {
      e.preventDefault();
      this.configForm.validateFieldsAndScroll((err, values) => {
        if (err) return;
        this.loadingACUpdate = true;
        apiClient
          .post("/buildings/" + this.selectedBuilding._id + "/updateConfig", {
            config: this.selectedBuilding.config,
          })
          .then((res) => {
            this.data = this.data.map((b) =>
              b._id == this.selectedBuilding._id
                ? { ...this.selectedBuilding }
                : b
            );

            this.closeAccessModal();
            this.$message.success(this.$t("etablissement.accessUpdated"));
            this.$emit("reload");
          })
          .catch(() =>
            this.$message.error(this.$t("error.changementNonEffectue"))
          )
          .finally(() => (this.loadingACUpdate = false));
      });
    },
    handleSearch(selectedKeys, confirm) {
      confirm();
    },

    handleReset(clearFilters) {
      clearFilters();
    },
  },
};
</script>
<style scoped>
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
/* Others */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.building-logo:hover {
  cursor: pointer;
}
::v-deep .ant-upload-list {
  width: 100%;
}
.email-item {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.email-input {
  flex: 1;
  margin-right: 8px;
}
.add-email-btn {
  width: 100%;
}
.phone-item {
  margin-bottom: 21px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.phone-input {
  flex: 1;
}
.add-phone-btn {
  width: 100%;
}
.director-item {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.director-input {
  flex: 1;
  margin-right: 8px;
}
.add-director-btn {
  width: 100%;
}
</style>
